module.exports = __webpack_public_path__ + "static/media/loading.887c4d28.gif";